__turbopack_context__.v({
  "accordion": "index-module__8D38na__accordion",
  "accordionContent": "index-module__8D38na__accordionContent",
  "accordionHeader": "index-module__8D38na__accordionHeader",
  "address": "index-module__8D38na__address",
  "appStoreButtonsRow": "index-module__8D38na__appStoreButtonsRow",
  "bottomBar": "index-module__8D38na__bottomBar",
  "bottomBarHeading": "index-module__8D38na__bottomBarHeading",
  "bottomBarSection": "index-module__8D38na__bottomBarSection",
  "columnSeparator": "index-module__8D38na__columnSeparator",
  "contactInfo": "index-module__8D38na__contactInfo",
  "contactLink": "index-module__8D38na__contactLink",
  "contentWrapper": "index-module__8D38na__contentWrapper",
  "copyrightRow": "index-module__8D38na__copyrightRow",
  "copyrightText": "index-module__8D38na__copyrightText",
  "dark": "index-module__8D38na__dark",
  "desktopSections": "index-module__8D38na__desktopSections",
  "findStoreLink": "index-module__8D38na__findStoreLink",
  "footerColumnWrapper": "index-module__8D38na__footerColumnWrapper",
  "footerColumnsGrid": "index-module__8D38na__footerColumnsGrid",
  "footerUtilityRow": "index-module__8D38na__footerUtilityRow",
  "footerWrapper": "index-module__8D38na__footerWrapper",
  "hsaFsaBadgeWrapper": "index-module__8D38na__hsaFsaBadgeWrapper",
  "light": "index-module__8D38na__light",
  "linksList": "index-module__8D38na__linksList",
  "mobileSections": "index-module__8D38na__mobileSections",
  "newBadge": "index-module__8D38na__newBadge",
  "regionSelectorWrapper": "index-module__8D38na__regionSelectorWrapper",
  "sectionHeading": "index-module__8D38na__sectionHeading",
  "socialIconsRow": "index-module__8D38na__socialIconsRow",
  "styledLink": "index-module__8D38na__styledLink",
  "wordmarkContainer": "index-module__8D38na__wordmarkContainer",
});
